function createBangleJSUiCode(x, y, z, renderBox, name, width, height, backgroundColor, textColor, text, fontSize, hitBoxOffset, vibrate) {

  return {
    active: true,
    name,
    x,
    y,
    z,
    width,
    height,
    backgroundColor,
    textColor,
    fontSize,
    text,
    hitBoxOffsetXLeft: hitBoxOffset.hitBoxOffsetXLeft,
    hitBoxOffsetXRight: hitBoxOffset.hitBoxOffsetXRight,
    hitBoxOffsetYTop: hitBoxOffset.hitBoxOffsetYTop,
    hitBoxOffsetYBottom: hitBoxOffset.hitBoxOffsetYBottom,
    renderBoxTlX: renderBox.tl.x,
    renderBoxTlY: renderBox.tl.y,
    renderBoxBrX: renderBox.br.x,
    renderBoxBrY: renderBox.br.y,
    vibrate,
    render: function () {
      if (!this.active) return;
      let fontSize = this.fontSize;
      g.setColor(this.backgroundColor);

      g.fillRect(this.x, this.y, this.x + this.width, this.y + this.height);
      g.setColor(this.textColor);
      g.setFontVector(fontSize);
      const maxTextWidth = this.width - 3;
      const maxTextHeight = this.height - 3;

      let textLines = g.wrapString(this.text, maxTextWidth);
      let textHeight = fontSize * (textLines.length === 1 ? 1 : textLines.length);
      let longestLine = textLines.reduce((longest, current) => current.length > longest.length ? current : longest, '');
      let longestLineLength = g.stringWidth(longestLine);

      while (textHeight > maxTextHeight && fontSize >= 11) {
        fontSize--;
        g.setFontVector(fontSize)
        textLines = g.wrapString(this.text, maxTextWidth);
        longestLine = textLines.reduce((longest, current) => current.length > longest.length ? current : longest, '');
        longestLineLength = g.stringWidth(longestLine);
        textHeight = fontSize * (textLines.length === 1 ? 1 : textLines.length);
      }

      const textXPosition = this.x + this.width / 2 - longestLineLength / 2;
      const textYPosition = this.y + this.height / 2 - (textHeight) / 2

      g.drawString(textLines.join('\n'), textXPosition, textYPosition, false);
    },
    wasTouched: function (e) {
      if (!this.active) return;

      return this.x - this.hitBoxOffsetXLeft <= e.x && e.x <= this.x + this.width + this.hitBoxOffsetXRight && this.y - this.hitBoxOffsetYTop <= e.y && e.y <= this.y + this.height + this.hitBoxOffsetYBottom;
    },
    onScreenTouch: function (e) {
      if (!this.active) return;

      if (this.vibrate) {
        Bangle.buzz(100, 0.2);
      }
    },
  }
}

module.exports = {
  createBangleJSUiCode
}
